// Arabic strings for the financeReports area (fixed-asset accounting: depreciation, disposals, book adjustments, FX, finance settings).
// Keyed by the English source text; {name} placeholders stay as-is.
export default {
  "(IAS 16 Cost Model)": "(نموذج التكلفة وفق IAS 16)",
  "(NOT balanced)": "(غير متوازن)",
  "(balanced)": "(متوازن)",
  "(period-end) or": "(نهاية الفترة) أو",
  "2 = double declining.": "2 = الرصيد المتناقص المضاعف.",
  "A different finance user must approve": "يجب أن يعتمده مستخدم مالي آخر",
  "A second finance user approves it before the journal posts. Depreciation then continues on the reduced carrying amount over the remaining life.": "يعتمده مستخدم مالي ثانٍ قبل ترحيل القيد. ثم يستمر الإهلاك على القيمة الدفترية المخفّضة خلال العمر المتبقي.",
  "Acc. dep.": "مجمع الإهلاك",
  "Account Title": "اسم الحساب",
  "Accounting Treatment": "المعالجة المحاسبية",
  "Accum. Dep.": "مجمع الإهلاك",
  "Accumulated Dep. Account": "حساب مجمع الإهلاك",
  "Accumulated Depreciation": "مجمع الإهلاك",
  "Accumulated Impairment Account (blank = Accumulated Dep.)": "حساب مجمع خسائر انخفاض القيمة (فارغ = مجمع الإهلاك)",
  "Accumulated depreciation": "مجمع الإهلاك",
  "Accumulated impairment": "مجمع انخفاض القيمة",
  "Action": "الإجراء",
  "Active Book & Conventions": "الدفتر النشط والأعراف",
  "Active Run": "التشغيل النشط",
  "Add": "إضافة",
  "Add a rate (units of {currency} for one unit of the property currency)": "إضافة سعر (وحدات {currency} مقابل وحدة واحدة من عملة العقار)",
  "Add at least one component": "أضف مكوّنًا واحدًا على الأقل",
  "Add column": "إضافة عمود",
  "Add component": "إضافة مكوّن",
  "Adjustment": "التسوية",
  "Adjustment Amount ({currency})": "مبلغ التسوية ({currency})",
  "Adjustment {run} posted in {period} as journal {journal}, referencing {original} of the original run. The closed period was not changed.": "تم ترحيل التسوية {run} في {period} كقيد يومية {journal} بالإشارة إلى {original} من التشغيل الأصلي. لم تتغير الفترة المقفلة.",
  "Adjustments": "التسويات",
  "All": "الكل",
  "All Approvals": "كل حالات الاعتماد",
  "All Disposal Types": "كل أنواع الاستبعاد",
  "All Periods": "كل الفترات",
  "All USALI Departments": "كل أقسام USALI",
  "All types": "كل الأنواع",
  "Apply rate": "تطبيق السعر",
  "Approval is required": "الاعتماد مطلوب",
  "Approve": "اعتماد",
  "Approve & Post Write-Off": "اعتماد وترحيل الشطب",
  "Approve and post the journal": "اعتماد القيد وترحيله",
  "Approve and post the write-off": "اعتماد الشطب وترحيله",
  "Approved": "معتمد",
  "Approved by {name}": "اعتمده {name}",
  "Approved disposal journals for {period}:": "قيود الاستبعاد المعتمدة لـ {period}:",
  "Approving will permanently retire asset from the fixed asset register and trigger a GL write-off journal entry.": "سيؤدي الاعتماد إلى إخراج الأصل نهائيًا من سجل الأصول الثابتة وإنشاء قيد شطب في دفتر الأستاذ العام.",
  "Asset & Serial": "الأصل والرقم التسلسلي",
  "Asset Cost Account": "حساب تكلفة الأصل",
  "Asset Description": "وصف الأصل",
  "Asset Disposals & Write-Offs": "استبعاد الأصول وشطبها",
  "Asset Tag (e.g. AST-MIA-0081)": "وسم الأصل (مثل AST-MIA-0081)",
  "AssetOS validates every line item. Go-Live confirmation is strictly blocked until your entered control totals match the imported file with": "يتحقق AssetOS من كل بند. يُمنع تأكيد بدء التشغيل حتى تطابق إجماليات المراقبة المدخلة الملف المستورد بفرق",
  "Assets Retired MTD": "الأصول المستبعدة منذ بداية الشهر",
  "Audit trail": "سجل التدقيق",
  "Autofill Sample Asset": "تعبئة أصل نموذجي تلقائيًا",
  "Average": "متوسط",
  "Average rate": "السعر المتوسط",
  "Awaiting": "بانتظار",
  "Balanced Total:": "الإجمالي المتوازن:",
  "Below threshold expensed.": "ما دون الحد يُحمَّل كمصروف.",
  "Below-Threshold Assets": "أصول دون الحد",
  "Book Policies": "سياسات الدفتر",
  "Book adjustments": "تسويات الدفتر",
  "Book currency": "عملة الدفتر",
  "Book history ({n})": "سجل الدفتر ({n})",
  "Book loss charged to each category's Loss on Disposal account": "خسارة دفترية تُحمَّل على حساب خسارة الاستبعاد لكل فئة",
  "Book:": "الدفتر:",
  "Books": "الدفاتر",
  "Books, cost": "دفترًا، التكلفة",
  "Both Cost and Accumulated Depreciation differences are exactly {currency} 0.00. Ready to execute opening balance migration and seed register.": "فرقا التكلفة ومجمع الإهلاك يساويان تمامًا {currency} 0.00. جاهز لترحيل الأرصدة الافتتاحية وتعبئة السجل.",
  "CSV import": "استيراد CSV",
  "Calculate & Generate Journal": "احتساب وإنشاء القيد",
  "Calculate period depreciation charges under single IFRS book (IAS 16) for all active qualifying fixed assets.": "احتساب أعباء إهلاك الفترة وفق دفتر IFRS الموحد (IAS 16) لجميع الأصول الثابتة المؤهلة النشطة.",
  "Calculate the monthly depreciation run": "احتساب تشغيل الإهلاك الشهري",
  "Calculating for": "الاحتساب لـ",
  "Cap. Threshold": "حد الرسملة",
  "Capital Asset Decommissioning": "إخراج الأصول الرأسمالية من الخدمة",
  "Capital Assets (IAS 16)": "الأصول الرأسمالية (IAS 16)",
  "Capitalisation Threshold ({currency})": "حد الرسملة ({currency})",
  "Carrying": "الدفترية",
  "Carrying amount": "القيمة الدفترية",
  "Category Book Policies": "سياسات دفتر الفئات",
  "Category book policy:": "سياسة دفتر الفئة:",
  "Category book policy: ": "سياسة دفتر الفئة: ",
  "Category:": "الفئة:",
  "Charitable Community Donation": "تبرع خيري للمجتمع",
  "Charitable Donation": "تبرع خيري",
  "Choose a Book to see its carrying amount, components and history.": "اختر دفترًا لعرض قيمته الدفترية ومكوّناته وسجله.",
  "Choose a category": "اختر فئة",
  "Choose a period in the filters first.": "اختر فترة من عوامل التصفية أولًا.",
  "Choose an asset": "اختر أصلًا",
  "Choose an existing asset tag from this property": "اختر وسم أصل موجودًا من هذا العقار",
  "Choose an open effective-from period": "اختر فترة سريان مفتوحة",
  "Choose the fields, rename the headers and set the order your ledger expects. Depreciation, disposal and write-off journals use the same layout.": "اختر الحقول وأعد تسمية العناوين ورتّبها كما يتوقع دفتر الأستاذ لديك. تستخدم قيود الإهلاك والاستبعاد والشطب التخطيط نفسه.",
  "Choose the group reporting currency first.": "اختر عملة تقارير المجموعة أولًا.",
  "Clear": "مسح",
  "Close {period}": "إقفال {period}",
  "Closed": "مقفلة",
  "Columns:": "الأعمدة:",
  "Component": "المكوّن",
  "Component name": "اسم المكوّن",
  "Component only:": "المكوّن فقط:",
  "Component {n} cost": "تكلفة المكوّن {n}",
  "Component {n} method": "طريقة المكوّن {n}",
  "Component {n} name": "اسم المكوّن {n}",
  "Component {n} useful life in months": "العمر الإنتاجي للمكوّن {n} بالأشهر",
  "Component:": "المكوّن:",
  "Components": "المكوّنات",
  "Configure Category Book Policy": "إعداد سياسة دفتر الفئة",
  "Confirm & Seed Opening Balances": "تأكيد الأرصدة الافتتاحية وتعبئتها",
  "Confirm: Post & Lock Period": "تأكيد: ترحيل الفترة وإقفالها",
  "Control Total": "إجمالي المراقبة",
  "Control totals do not match imported data. Differences must be {currency} 0.00 before go-live is permitted.": "إجماليات المراقبة لا تطابق البيانات المستوردة. يجب أن تكون الفروق {currency} 0.00 قبل السماح ببدء التشغيل.",
  "Convention": "العُرف",
  "Convention: per Category Book Policy (default Next-Month)": "العُرف: حسب سياسة دفتر الفئة (الافتراضي: الشهر التالي)",
  "Cost": "التكلفة",
  "Credit": "دائن",
  "Credit ({currency})": "دائن ({currency})",
  "Currencies & FX Rates": "العملات وأسعار الصرف",
  "Currencies and exchange rates": "العملات وأسعار الصرف",
  "Currency:": "العملة:",
  "Current NBV:": "صافي القيمة الدفترية الحالية:",
  "Current Open Period": "الفترة المفتوحة الحالية",
  "Custom layout": "تخطيط مخصّص",
  "Customer rate": "سعر العميل",
  "DRAFT": "مسودة",
  "Debit": "مدين",
  "Debit ({currency})": "مدين ({currency})",
  "Declining Balance Factor": "معامل الرصيد المتناقص",
  "Declining balance": "الرصيد المتناقص",
  "Decommissioned fixed assets": "الأصول الثابتة المُخرجة من الخدمة",
  "Default {pct}%. Cumulative repairs at or above this raise the signal.": "الافتراضي {pct}%. الإصلاحات المتراكمة عند هذه النسبة أو أعلى منها تُطلق التنبيه.",
  "Default {rate}% (UAE).": "الافتراضي {rate}% (الإمارات).",
  "Delete": "حذف",
  "Department Head endorsement is required first": "يلزم أولًا تأييد رئيس القسم",
  "Department Head endorsement, then Finance Controller": "تأييد رئيس القسم، ثم المراقب المالي",
  "Department Head endorsement:": "تأييد رئيس القسم:",
  "Depreciation Convention": "عُرف الإهلاك",
  "Depreciation Expense Account": "حساب مصروف الإهلاك",
  "Depreciation Method": "طريقة الإهلاك",
  "Depreciation Rule: ": "قاعدة الإهلاك: ",
  "Depreciation Runs & GL Schedules": "تشغيلات الإهلاك وجداول الأستاذ العام",
  "Depreciation still owed up to the retirement month is charged when the request is submitted.": "يُحمَّل الإهلاك المستحق حتى شهر الاستبعاد عند تقديم الطلب.",
  "Direction": "الاتجاه",
  "Discard the draft": "تجاهل المسودة",
  "Disposal ID": "رقم الاستبعاد",
  "Disposal Method / Type": "طريقة / نوع الاستبعاد",
  "Disposal Type": "نوع الاستبعاد",
  "Disposal Type:": "نوع الاستبعاد:",
  "Disposal journals exported as {file}.": "تم تصدير قيود الاستبعاد باسم {file}.",
  "Disposal {ref} submitted for Department Head endorsement and Controller approval.": "تم تقديم الاستبعاد {ref} لتأييد رئيس القسم واعتماد المراقب المالي.",
  "Dispose of": "استبعاد",
  "Disposed {date}": "مستبعد {date}",
  "Download Template": "تنزيل القالب",
  "Downloaded {file}.": "تم تنزيل {file}.",
  "Draft - not yet posted": "مسودة - لم تُرحَّل بعد",
  "Draft run": "تشغيل مسودة",
  "Draft run discarded.": "تم تجاهل التشغيل المسودة.",
  "Drag and drop opening balances CSV file here, or click to browse": "اسحب ملف CSV للأرصدة الافتتاحية وأفلته هنا، أو انقر للاستعراض",
  "Each component needs a name, a cost above zero and a useful life in whole months": "يحتاج كل مكوّن إلى اسم وتكلفة أكبر من صفر وعمر إنتاجي بأشهر كاملة",
  "Each property keeps its books in its own currency. Reports that cover several properties are shown in the group currency: balances at the period-end rate, the period's depreciation at the average rate.": "يمسك كل عقار دفاتره بعملته الخاصة. تُعرض التقارير التي تشمل عدة عقارات بعملة المجموعة: الأرصدة بسعر نهاية الفترة، وإهلاك الفترة بالسعر المتوسط.",
  "Edit": "تعديل",
  "Edit {category}": "تعديل {category}",
  "Edits create a new policy version effective from a future open period. Prior closed accounting periods remain unchanged.": "تُنشئ التعديلات إصدارًا جديدًا من السياسة يسري من فترة مفتوحة مستقبلية. تبقى الفترات المحاسبية المقفلة السابقة دون تغيير.",
  "Effective": "السريان",
  "Effective Date:": "تاريخ السريان:",
  "Effective-From Period": "فترة بدء السريان",
  "Ending NBV": "صافي القيمة الدفترية الختامية",
  "Endorse as Department Head": "التأييد بصفة رئيس القسم",
  "Endorsed": "مؤيَّد",
  "Enter 1 to 600 whole months": "أدخل من 1 إلى 600 شهر كامل",
  "Enter a non-zero amount (negative reduces depreciation)": "أدخل مبلغًا غير صفري (السالب يُخفّض الإهلاك)",
  "Enter a threshold of 0 or more": "أدخل حدًا يساوي 0 أو أكثر",
  "Enter an impairment amount above zero": "أدخل مبلغ انخفاض قيمة أكبر من صفر",
  "Enter the retirement date": "أدخل تاريخ الاستبعاد",
  "Entered by": "أدخله",
  "Equipment & Model": "المعدّة والطراز",
  "Estimated Net P&L Impact": "الأثر الصافي المقدّر على الأرباح والخسائر",
  "Exception": "الاستثناء",
  "Exception type": "نوع الاستثناء",
  "Execute Monthly Depreciation Run": "تنفيذ تشغيل الإهلاك الشهري",
  "Execute Period Run": "تنفيذ تشغيل الفترة",
  "Execute the period run first": "نفّذ تشغيل الفترة أولًا",
  "Export GL Batch": "تصدير دفعة الأستاذ العام",
  "Export Write-Off Schedule": "تصدير جدول الشطب",
  "External Salvage Sale / Auction": "بيع خردة خارجي / مزاد",
  "FX rate missing - Finance to review": "سعر الصرف مفقود - تراجعه المالية",
  "Factor must be between 1 and 4": "يجب أن يكون المعامل بين 1 و4",
  "Field of column {n}": "حقل العمود {n}",
  "Field or fixed value": "حقل أو قيمة ثابتة",
  "File format": "صيغة الملف",
  "Finance Controller Sign-Off": "مصادقة المراقب المالي",
  "Finance Controller approval:": "اعتماد المراقب المالي:",
  "Finance Settings": "الإعدادات المالية",
  "Finance settings": "الإعدادات المالية",
  "Fiscal Month": "الشهر المالي",
  "Fiscal Year": "السنة المالية",
  "Fixed Asset Accounting": "محاسبة الأصول الثابتة",
  "Fixed value of column {n}": "القيمة الثابتة للعمود {n}",
  "Fixed value...": "قيمة ثابتة...",
  "Floor % must be between 0 and 100": "يجب أن تكون نسبة الحد الأدنى بين 0 و100",
  "Future Open": "مفتوحة مستقبلًا",
  "Future Open Period": "فترة مفتوحة مستقبلية",
  "GL (asset / dep. exp.)": "الأستاذ العام (الأصل / مصروف الإهلاك)",
  "GL Account": "حساب الأستاذ العام",
  "GL Account #": "رقم حساب الأستاذ العام",
  "GL Connector:": "موصل الأستاذ العام:",
  "GL Posting Sync": "مزامنة الترحيل إلى الأستاذ العام",
  "GL export layouts": "تخطيطات تصدير الأستاذ العام",
  "Gain": "ربح",
  "Gain / (Loss)": "ربح / (خسارة)",
  "Gain on Disposal Account": "حساب ربح الاستبعاد",
  "General Ledger & USALI Mapping": "ربط الأستاذ العام وأقسام USALI",
  "Give a reason of at least 10 characters": "اكتب سببًا من 10 أحرف على الأقل",
  "Give a rejection reason of at least 5 characters": "اكتب سبب رفض من 5 أحرف على الأقل",
  "Gross Value Retired": "إجمالي القيمة المستبعدة",
  "Group reporting currency": "عملة تقارير المجموعة",
  "Group reporting currency and exchange rates for reports across properties": "عملة تقارير المجموعة وأسعار الصرف للتقارير الشاملة لعدة عقارات",
  "Group reporting currency set to {currency}.": "تم تعيين عملة تقارير المجموعة إلى {currency}.",
  "Header": "العنوان",
  "Header of column {n}": "عنوان العمود {n}",
  "History": "السجل",
  "History of {category}": "سجل {category}",
  "Hospitality policy: ": "سياسة الضيافة: ",
  "I approve this adjustment as Finance Controller": "أعتمد هذه التسوية بصفتي المراقب المالي",
  "IAS 16 / USALI Allocations": "IAS 16 / توزيعات USALI",
  "IAS 16 Cost Model / Next-Month Convention / Single IFRS Book with USALI Department Allocation": "نموذج التكلفة وفق IAS 16 / عُرف الشهر التالي / دفتر IFRS موحد مع توزيع أقسام USALI",
  "IAS 8 / IAS 16 Compliant": "متوافق مع IAS 8 / IAS 16",
  "IAS 8 Change in Accounting Estimate:": "تغيير في التقدير المحاسبي وفق IAS 8:",
  "Impaired": "منخفض القيمة",
  "Impairment Loss Account": "حساب خسارة انخفاض القيمة",
  "Impairment amount": "مبلغ انخفاض القيمة",
  "Impairment approvals": "اعتمادات انخفاض القيمة",
  "Impairment reason": "سبب انخفاض القيمة",
  "Impairment {ref} approved and journal posted.": "تم اعتماد انخفاض القيمة {ref} وترحيل القيد.",
  "Impairment {ref} for {amount} is waiting for a second finance approver.": "انخفاض القيمة {ref} بمبلغ {amount} بانتظار معتمد مالي ثانٍ.",
  "Impairment {ref} rejected.": "تم رفض انخفاض القيمة {ref}.",
  "Impairments, components and transfers": "انخفاض القيمة والمكوّنات والتحويلات",
  "Import Opening Fixed Asset Balances": "استيراد الأرصدة الافتتاحية للأصول الثابتة",
  "Import opening fixed asset balances": "استيراد الأرصدة الافتتاحية للأصول الثابتة",
  "Import rates from CSV": "استيراد الأسعار من CSV",
  "Imported File Total:": "إجمالي الملف المستورد:",
  "In from {property}": "وارد من {property}",
  "In service": "في الخدمة",
  "In use": "قيد الاستخدام",
  "Includes depreciation to disposal of {amount} ({n} {unit})": "يشمل إهلاكًا حتى الاستبعاد بمبلغ {amount} ({n} {unit})",
  "Infor Ledger": "دفتر Infor",
  "Initiate Asset Decommissioning & Retirement": "بدء إخراج الأصل من الخدمة واستبعاده",
  "Initiate Asset Retirement": "بدء استبعاد أصل",
  "Initiate an asset retirement": "بدء استبعاد أصل",
  "Initiated By (Property Staff)": "بدأه (موظفو العقار)",
  "Items acquired below threshold expensed on purchase; tracked physically without ledger book": "تُحمَّل البنود المقتناة دون الحد كمصروف عند الشراء، وتُتابَع فعليًا دون دفتر",
  "Journal": "القيد",
  "Journal Ref:": "مرجع القيد:",
  "Journal file": "ملف القيد",
  "Journal that will post on approval": "القيد الذي سيُرحَّل عند الاعتماد",
  "Journal {ref} posted to Xero as a Manual Journal.": "تم ترحيل القيد {ref} إلى Xero كقيد يدوي.",
  "Justification & Defect Notes:": "المبررات وملاحظات العيوب:",
  "Layout reset to the standard template.": "تمت إعادة التخطيط إلى القالب القياسي.",
  "Layout saved. Journal exports for this target now use these columns.": "تم حفظ التخطيط. تستخدم صادرات القيود لهذه الوجهة هذه الأعمدة الآن.",
  "Ledger": "دفتر الأستاذ",
  "Letters, digits, dot, dash only (max 24)": "أحرف وأرقام ونقطة وشرطة فقط (24 كحد أقصى)",
  "Life": "العمر",
  "Life (mo)": "العمر (شهر)",
  "Life (months)": "العمر (بالأشهر)",
  "Life / method": "العمر / الطريقة",
  "Life Rem.": "العمر المتبقي",
  "List the significant parts with their own cost and life (for example a chiller's compressor). The rest of the cost stays as the remaining component on the policy's life. Depreciation and impairment so far are shared by cost.": "اذكر الأجزاء الجوهرية بتكلفتها وعمرها الخاصين (مثل ضاغط وحدة التبريد). يبقى باقي التكلفة مكوّنًا متبقيًا على عمر السياسة. يُوزَّع الإهلاك وانخفاض القيمة حتى الآن حسب التكلفة.",
  "Loading disposals...": "جارٍ تحميل عمليات الاستبعاد...",
  "Loading policies...": "جارٍ تحميل السياسات...",
  "Loading schedule...": "جارٍ تحميل الجدول...",
  "Loading settings...": "جارٍ تحميل الإعدادات...",
  "Location": "الموقع",
  "Loss": "خسارة",
  "Loss / Theft": "فقدان / سرقة",
  "Loss on Disposal Account": "حساب خسارة الاستبعاد",
  "Map the GL accounts on the Book Policy": "اربط حسابات الأستاذ العام في سياسة الدفتر",
  "Method": "الطريقة",
  "Missing / Theft Write-Off": "شطب مفقود / مسروق",
  "Move down": "نقل لأسفل",
  "Move up": "نقل لأعلى",
  "N/A (Expensed)": "لا ينطبق (مُحمَّل كمصروف)",
  "NOT RUN": "لم يُشغَّل",
  "Name of the remaining component": "اسم المكوّن المتبقي",
  "Net Book Value:": "صافي القيمة الدفترية:",
  "Net Loss on Disposal": "صافي خسارة الاستبعاد",
  "Net P&L Gain on Write-Off:": "صافي الربح من الشطب:",
  "Net P&L Loss on Write-Off:": "صافي الخسارة من الشطب:",
  "No Books have moved in or out of this property. A Book follows its asset when an inter-property transfer is received.": "لم تنتقل أي دفاتر من هذا العقار أو إليه. ينتقل الدفتر مع أصله عند استلام تحويل بين العقارات.",
  "No Books match. Books are opened by the first depreciation run of a capitalised asset or by an opening-balance import.": "لا توجد دفاتر مطابقة. تُفتح الدفاتر بأول تشغيل إهلاك لأصل مرسمل أو باستيراد رصيد افتتاحي.",
  "No asset disposal records match your filter criteria.": "لا توجد سجلات استبعاد أصول تطابق معايير التصفية.",
  "No asset records match the specified filters.": "لا توجد سجلات أصول تطابق عوامل التصفية المحددة.",
  "No categories match.": "لا توجد فئات مطابقة.",
  "No changes recorded yet.": "لا توجد تغييرات مسجلة بعد.",
  "No exceptions: every capitalised asset has a cost, an in-service date, a Book Policy and a GL mapping.": "لا استثناءات: لكل أصل مرسمل تكلفة وتاريخ بدء خدمة وسياسة دفتر وربط بالأستاذ العام.",
  "No impairments here. Record one from a Book on the Books tab; a second finance user approves it.": "لا توجد حالات انخفاض قيمة هنا. سجّل واحدة من دفتر في تبويب الدفاتر، ويعتمدها مستخدم مالي ثانٍ.",
  "No rates yet - add the period-end and average rates for each property currency.": "لا توجد أسعار بعد - أضف سعر نهاية الفترة والسعر المتوسط لكل عملة عقار.",
  "Nothing is saved if any row is wrong.": "لا يُحفظ شيء إذا كان أي صف خاطئًا.",
  "Nothing was imported: {n} error found. Fix the file and upload it again.": "لم يُستورد شيء: وُجد {n} خطأ. صحّح الملف وارفعه مجددًا.",
  "Nothing was imported: {n} errors found. Fix the file and upload it again.": "لم يُستورد شيء: وُجدت {n} أخطاء. صحّح الملف وارفعه مجددًا.",
  "OE Amortisation (Months)": "إطفاء معدات التشغيل (بالأشهر)",
  "OE Base Stock": "المخزون الأساسي لمعدات التشغيل",
  "OE Expense Account": "حساب مصروف معدات التشغيل",
  "OE Residual Floor %": "نسبة الحد الأدنى المتبقي لمعدات التشغيل %",
  "Only Finance or the Customer Admin can change currencies and rates.": "لا يمكن تغيير العملات والأسعار إلا للمالية أو مسؤول العميل.",
  "Only Finance or the Customer Admin can change these settings.": "لا يمكن تغيير هذه الإعدادات إلا للمالية أو مسؤول العميل.",
  "Only the Finance Controller can approve": "لا يعتمد إلا المراقب المالي",
  "Only the Finance Controller can change export layouts.": "لا يمكن تغيير تخطيطات التصدير إلا للمراقب المالي.",
  "Only the Finance Controller can execute a run": "لا ينفّذ التشغيل إلا المراقب المالي",
  "Only the Finance Controller can import opening balances": "لا يستورد الأرصدة الافتتاحية إلا المراقب المالي",
  "Only the component {name} ({amount} carrying amount)": "المكوّن {name} فقط ({amount} قيمة دفترية)",
  "Open period:": "الفترة المفتوحة:",
  "Opening Balances": "الأرصدة الافتتاحية",
  "Opening balances confirmed: {books} Books created with an opening-balance event ({linked} linked to Tagged Assets, {drafts} draft assets for the first scan walk). The first Depreciation Run uses the remaining life.": "تم تأكيد الأرصدة الافتتاحية: أُنشئ {books} دفترًا بحدث رصيد افتتاحي ({linked} مرتبطة بأصول موسومة، و{drafts} أصول مسودة لجولة المسح الأولى). يستخدم أول تشغيل إهلاك العمر المتبقي.",
  "Opening balances file": "ملف الأرصدة الافتتاحية",
  "Opening balances in the register:": "الأرصدة الافتتاحية في السجل:",
  "Operating Equipment base stock amortised to 50% floor over 36 mos; replenishments expensed immediately to P&L": "يُطفأ المخزون الأساسي لمعدات التشغيل حتى حد أدنى 50% خلال 36 شهرًا، وتُحمَّل التعويضات فورًا على الأرباح والخسائر",
  "Operating Equipment base stock uses a 50% floor.": "يستخدم المخزون الأساسي لمعدات التشغيل حدًا أدنى 50%.",
  "Oracle General Ledger CSV": "ملف CSV لدفتر الأستاذ العام في Oracle",
  "Order": "الترتيب",
  "Original Cost:": "التكلفة الأصلية:",
  "Original acquisition cost removed": "تكلفة الاقتناء الأصلية المستبعدة",
  "Original run": "التشغيل الأصلي",
  "Out to {property}": "صادر إلى {property}",
  "Own VAT rate (%)": "معدل ضريبة القيمة المضافة الخاص (%)",
  "POSTED": "مرحَّل",
  "Pending": "معلّق",
  "Pending Approval": "بانتظار الاعتماد",
  "Period": "الفترة",
  "Period Charge": "عبء الفترة",
  "Period Depreciation": "إهلاك الفترة",
  "Period {period} closed. Closed periods can no longer receive policy changes.": "تم إقفال الفترة {period}. لا يمكن للفترات المقفلة تلقي تغييرات في السياسات.",
  "Period-end": "نهاية الفترة",
  "Period-end rate": "سعر نهاية الفترة",
  "Period:": "الفترة:",
  "Policy History - {category}": "سجل السياسة - {category}",
  "Policy Method": "طريقة السياسة",
  "Policy effective in {period} (threshold, method, life, convention)": "السياسة السارية في {period} (الحد، الطريقة، العمر، العُرف)",
  "Policy in force for period": "السياسة السارية للفترة",
  "Policy pages": "صفحات السياسات",
  "Positive adds depreciation, negative reverses it.": "الموجب يضيف إهلاكًا، والسالب يعكسه.",
  "Post Adjustment": "ترحيل تسوية",
  "Post Adjustment to the Next Open Period": "ترحيل تسوية إلى الفترة المفتوحة التالية",
  "Post Run": "ترحيل التشغيل",
  "Post the run first - only a posted run can be exported to the General Ledger.": "رحّل التشغيل أولًا - لا يُصدَّر إلى دفتر الأستاذ العام إلا التشغيل المرحَّل.",
  "Post to Xero": "الترحيل إلى Xero",
  "Post to Xero Manual Journal": "الترحيل إلى قيد Xero اليدوي",
  "Posted - immutable": "مرحَّل - غير قابل للتعديل",
  "Posted in": "رُحِّل في",
  "Posted journal {ref}": "القيد المرحَّل {ref}",
  "Posted runs cannot be deleted": "لا يمكن حذف التشغيلات المرحَّلة",
  "Posted runs cannot be recalculated": "لا يمكن إعادة احتساب التشغيلات المرحَّلة",
  "Posted to Xero as a draft Manual Journal ({ref}).": "تم الترحيل إلى Xero كقيد يدوي مسودة ({ref}).",
  "Posting Date:": "تاريخ الترحيل:",
  "Posting is permanent.": "الترحيل نهائي.",
  "Press Reject again to confirm.": "اضغط رفض مرة أخرى للتأكيد.",
  "Prev": "السابق",
  "Preview - run not yet calculated": "معاينة - لم يُحتسب التشغيل بعد",
  "Preview GL Journal": "معاينة قيد الأستاذ العام",
  "Preview the balanced GL journal": "معاينة قيد الأستاذ العام المتوازن",
  "Prior NBV": "صافي القيمة الدفترية السابقة",
  "Prior closed accounting periods remain strictly immutable. A Book Policy edit creates a new version that takes effect from a future open period.": "تبقى الفترات المحاسبية المقفلة السابقة غير قابلة للتعديل إطلاقًا. يُنشئ تعديل سياسة الدفتر إصدارًا جديدًا يسري من فترة مفتوحة مستقبلية.",
  "Proceeds must be 0.00 or more": "يجب أن تكون العائدات 0.00 أو أكثر",
  "Property transfers": "تحويلات العقارات",
  "Property:": "العقار:",
  "Prospective Adjustment Policy Active (IAS 8):": "سياسة التسوية المستقبلية مفعّلة (IAS 8):",
  "Qualifying Capital Assets": "الأصول الرأسمالية المؤهلة",
  "Rate": "السعر",
  "Rate applied": "المعدل المطبّق",
  "Rate date": "تاريخ السعر",
  "Rate deleted.": "تم حذف السعر.",
  "Rate saved: 1 {currency} = {rate} {group} ({type}, {date}).": "تم حفظ السعر: 1 {currency} = {rate} {group} ({type}، {date}).",
  "Rate type": "نوع السعر",
  "Rates CSV file": "ملف CSV للأسعار",
  "Rates CSV text": "نص CSV للأسعار",
  "Rates on file": "الأسعار المسجلة",
  "Reason & Inspection Documentation": "السبب ووثائق الفحص",
  "Reason (for example: flood damage found at inspection)": "السبب (مثال: ضرر فيضان اكتُشف أثناء الفحص)",
  "Reason for rejecting": "سبب الرفض",
  "Reason for rejection": "سبب الرفض",
  "Recalculate": "إعادة الاحتساب",
  "Recalculate the draft": "إعادة احتساب المسودة",
  "Reconciliation Blocked:": "التسوية محظورة:",
  "Reconciliation Verified:": "تم التحقق من التسوية:",
  "Record an impairment write-down": "تسجيل تخفيض لانخفاض القيمة",
  "Recoverable input VAT is kept out of asset cost; VAT marked as not reclaimable on a receipt is added to cost.": "تُستبعد ضريبة المدخلات القابلة للاسترداد من تكلفة الأصل، وتُضاف الضريبة المعلَّمة كغير قابلة للاسترداد في الإيصال إلى التكلفة.",
  "Reject": "رفض",
  "Rejected": "مرفوض",
  "Remaining component:": "المكوّن المتبقي:",
  "Remove column": "إزالة العمود",
  "Remove component": "إزالة المكوّن",
  "Repair Expense Account": "حساب مصروف الإصلاح",
  "Repair-or-Replace threshold (% of replacement cost)": "حد الإصلاح أو الاستبدال (% من تكلفة الاستبدال)",
  "Required columns: Asset/Pool Ref, Category, Location, Cost AED, Accum Dep AED, In-Service Date, Remaining Life. Optional: Tag Code, Serial Number. Enter amounts in the property currency ({currency}).": "الأعمدة المطلوبة: Asset/Pool Ref وCategory وLocation وCost AED وAccum Dep AED وIn-Service Date وRemaining Life. اختيارية: Tag Code وSerial Number. أدخل المبالغ بعملة العقار ({currency}).",
  "Reset to standard": "إعادة إلى القياسي",
  "Residual % must be between 0 and 100": "يجب أن تكون النسبة المتبقية بين 0 و100",
  "Residual Value %": "القيمة المتبقية %",
  "Retire fixed assets, compute Net Book Value write-offs, log proceeds and obtain Controller sign-off.": "استبعد الأصول الثابتة، واحسب شطب صافي القيمة الدفترية، وسجّل العائدات، واحصل على مصادقة المراقب المالي.",
  "Retirement Date": "تاريخ الاستبعاد",
  "Retirement Effective Date": "تاريخ سريان الاستبعاد",
  "Review & Sign": "مراجعة وتوقيع",
  "Review the journal, then post the run to lock the period.": "راجع القيد، ثم رحّل التشغيل لإقفال الفترة.",
  "Routing Approver": "مسار الاعتماد",
  "Row": "الصف",
  "Run monthly depreciation, review GL journals and manage category book policies.": "شغّل الإهلاك الشهري، وراجع قيود الأستاذ العام، وأدِر سياسات دفاتر الفئات.",
  "Run recalculated.": "تمت إعادة احتساب التشغيل.",
  "Run {run} calculated for {period}: {count} assets, {amount}.": "تم احتساب التشغيل {run} لـ {period}: {count} أصلًا، {amount}.",
  "Run {run} posted as journal {journal}. The period is locked: a posted run is immutable and cannot be recalculated.": "تم ترحيل التشغيل {run} كقيد يومية {journal}. الفترة مقفلة: التشغيل المرحَّل غير قابل للتعديل ولا لإعادة الاحتساب.",
  "Run:": "التشغيل:",
  "SAP S/4HANA Journal CSV": "ملف CSV لقيود SAP S/4HANA",
  "Salvage / Scrap Proceeds Received ({currency})": "عائدات الخردة / الإنقاذ المستلمة ({currency})",
  "Salvage Proceeds": "عائدات الخردة",
  "Salvage Proceeds:": "عائدات الخردة:",
  "Same currency": "العملة نفسها",
  "Save": "حفظ",
  "Save Versioned Policy": "حفظ إصدار السياسة",
  "Save layout": "حفظ التخطيط",
  "Save settings": "حفظ الإعدادات",
  "Saved by": "حفظه",
  "Saved. VAT {vat}% (properties without their own rate), Repair-or-Replace at {pct}% of replacement cost.": "تم الحفظ. ضريبة القيمة المضافة {vat}% (للعقارات التي ليس لها معدل خاص)، والإصلاح أو الاستبدال عند {pct}% من تكلفة الاستبدال.",
  "Schedule pages": "صفحات الجدول",
  "Scrap / Environmental Recycling": "خردة / إعادة تدوير بيئية",
  "Scrap / Recycled": "خردة / معاد تدويرها",
  "Scrap auctions & vendor buyback": "مزادات الخردة وإعادة الشراء من المورّد",
  "Search Books": "البحث في الدفاتر",
  "Search asset tag, name or Book reference": "ابحث بوسم الأصل أو اسمه أو مرجع الدفتر",
  "Search asset tag, name, disposal ID...": "ابحث بوسم الأصل أو الاسم أو رقم الاستبعاد...",
  "Search categories": "البحث في الفئات",
  "Search category...": "ابحث عن فئة...",
  "Search tag, equipment, serial...": "ابحث بالوسم أو المعدّة أو الرقم التسلسلي...",
  "Select Decommissioned Fixed Asset": "اختر الأصل الثابت المُخرج من الخدمة",
  "Select an asset": "اختر أصلًا",
  "Send this journal to the GL:": "إرسال هذا القيد إلى الأستاذ العام:",
  "Settings for": "إعدادات",
  "Show": "عرض",
  "Show more ({n} more)": "عرض المزيد ({n} إضافية)",
  "Showing 0 records": "عرض 0 سجل",
  "Showing the first {shown} of {total} rows.": "عرض أول {shown} من {total} صفًا.",
  "Showing {from}-{to} of {total} disposal records": "عرض {from}-{to} من {total} سجل استبعاد",
  "Showing {shown} of {total} records": "عرض {shown} من {total} سجل",
  "Single IFRS Book": "دفتر IFRS الموحد",
  "Sold / Salvage": "مُباع / خردة",
  "Split into components": "تقسيم إلى مكوّنات",
  "Split the Book": "تقسيم الدفتر",
  "Standard template": "القالب القياسي",
  "Standard:": "المعيار:",
  "State reason for retirement, engineering inspection results, and irreparable defect...": "اذكر سبب الاستبعاد ونتائج الفحص الهندسي والعيب غير القابل للإصلاح...",
  "Status": "الحالة",
  "Step 1: Download & Upload CSV Template": "الخطوة 1: تنزيل قالب CSV ورفعه",
  "Step 2: Enter Prior Ledger Control Totals": "الخطوة 2: إدخال إجماليات المراقبة من الدفتر السابق",
  "Straight line": "القسط الثابت",
  "Submit for Controller Approval": "تقديم لاعتماد المراقب المالي",
  "Submit for approval": "تقديم للاعتماد",
  "Sun Systems Ledger": "دفتر Sun Systems",
  "System": "النظام",
  "Target": "الوجهة",
  "The Book is now split into components; each one depreciates on its own life and method from the next run.": "تم تقسيم الدفتر إلى مكوّنات، ويُهلَك كل منها وفق عمره وطريقته الخاصين بدءًا من التشغيل التالي.",
  "The asset stays in service.": "يبقى الأصل في الخدمة.",
  "The asset stays in service; only this component leaves the Book.": "يبقى الأصل في الخدمة، ويخرج هذا المكوّن فقط من الدفتر.",
  "The period is locked for this property; the run cannot be edited, recalculated or deleted by any role. Later corrections are posted as an Adjustment in the next open period.": "تُقفل الفترة لهذا العقار، ولا يمكن لأي دور تعديل التشغيل أو إعادة احتسابه أو حذفه. تُرحَّل التصحيحات اللاحقة كتسوية في الفترة المفتوحة التالية.",
  "The receipt went through; add the closing rate for the transfer date under FX rates, then apply it here.": "تم الاستلام؛ أضف سعر الإقفال لتاريخ التحويل ضمن أسعار الصرف، ثم طبّقه هنا.",
  "The retirement date cannot be in the future": "لا يمكن أن يكون تاريخ الاستبعاد في المستقبل",
  "The whole asset ({amount} carrying amount)": "الأصل بالكامل ({amount} قيمة دفترية)",
  "There is no asset available for retirement at this property.": "لا يوجد أصل متاح للاستبعاد في هذا العقار.",
  "These assets are left out of the run.": "هذه الأصول مستبعدة من التشغيل.",
  "This disposal is already decided": "تم البت في هذا الاستبعاد مسبقًا",
  "This disposal type cannot carry proceeds - enter 0.00": "لا يمكن أن يتضمن نوع الاستبعاد هذا عائدات - أدخل 0.00",
  "Threshold": "الحد",
  "Threshold:": "الحد:",
  "Title": "العنوان",
  "Total Accumulated Dep. ({currency})": "إجمالي مجمع الإهلاك ({currency})",
  "Total Cost Basis ({currency})": "إجمالي أساس التكلفة ({currency})",
  "Treatment": "المعالجة",
  "Type": "النوع",
  "USALI Department Allocations: Enabled": "توزيعات أقسام USALI: مفعّلة",
  "USALI Dept": "قسم USALI",
  "USALI Dept / Cost Center": "قسم USALI / مركز التكلفة",
  "USALI department": "قسم USALI",
  "Use at most 2 decimal places": "استخدم منزلتين عشريتين كحد أقصى",
  "Useful Life (Months)": "العمر الإنتاجي (بالأشهر)",
  "Useful life must be 1 to 600 whole months": "يجب أن يكون العمر الإنتاجي من 1 إلى 600 شهر كامل",
  "VAT & repairs": "ضريبة القيمة المضافة والإصلاحات",
  "VAT rate (%)": "معدل ضريبة القيمة المضافة (%)",
  "VAT rate for {name}": "معدل ضريبة القيمة المضافة لـ {name}",
  "VAT rate, Repair-or-Replace threshold and GL export layouts": "معدل ضريبة القيمة المضافة وحد الإصلاح أو الاستبدال وتخطيطات تصدير الأستاذ العام",
  "Validating rows...": "جارٍ التحقق من الصفوف...",
  "Variance Difference:": "فرق التباين:",
  "Version": "الإصدار",
  "Versioned Book Policy saved for {category}: version {version} takes effect prospectively from {period}. Prior periods remain unchanged.": "تم حفظ إصدار سياسة الدفتر لـ {category}: يسري الإصدار {version} مستقبليًا من {period}. تبقى الفترات السابقة دون تغيير.",
  "View": "عرض",
  "Waiting for approval": "بانتظار الاعتماد",
  "What to fix": "ما يجب إصلاحه",
  "Write a Book down for impairment, split it into components, and see Books moved between properties.": "خفّض قيمة دفتر لانخفاض القيمة، أو قسّمه إلى مكوّنات، واطّلع على الدفاتر المنقولة بين العقارات.",
  "Write-off schedule exported as {file}.": "تم تصدير جدول الشطب باسم {file}.",
  "Xero Accounting API": "واجهة Xero المحاسبية",
  "Xero Manual Journal (Balanced Double-Entry in {currency})": "قيد Xero اليدوي (قيد مزدوج متوازن بـ {currency})",
  "Xero Manual Journal CSV": "ملف CSV لقيد Xero اليدوي",
  "You (signed-in user)": "أنت (المستخدم الحالي)",
  "You can still post; the list is kept with the run.": "لا يزال بإمكانك الترحيل؛ تُحفظ القائمة مع التشغيل.",
  "You entered this one - another finance user approves it.": "أنت من أدخل هذا - يعتمده مستخدم مالي آخر.",
  "Your properties use {currencies} besides {group}.": "تستخدم عقاراتك {currencies} إضافة إلى {group}.",
  "Your role cannot initiate disposals": "لا يمكن لدورك بدء عمليات الاستبعاد",
  "accumulated depreciation": "مجمع الإهلاك",
  "active": "ساري",
  "at or above their Category Book Policy threshold. Nothing is posted until you review and post the journal.": "عند حد سياسة دفتر فئتها أو أعلى منه. لا يُرحَّل شيء حتى تراجع القيد وترحّله.",
  "average": "متوسط",
  "closed": "مقفلة",
  "closing rate {date}": "سعر الإقفال {date}",
  "customised": "مخصّص",
  "exception": "استثناء",
  "exceptions": "استثناءات",
  "in service": "في الخدمة منذ",
  "items acquired below the threshold are expensed on purchase and tracked physically without a ledger book": "تُحمَّل البنود المقتناة دون الحد كمصروف عند الشراء وتُتابَع فعليًا دون دفتر",
  "month": "شهر",
  "months": "أشهر",
  "onward": "فصاعدًا",
  "open": "مفتوحة",
  "per Category Book Policy": "حسب سياسة دفتر الفئة",
  "period-end": "نهاية الفترة",
  "rate_type is": "rate_type هو",
  "saved v{version} effective {period} on": "حفظ الإصدار v{version} الساري من {period} في",
  "scheduled": "مجدول",
  "superseded": "مستبدَل",
  "the selected period": "الفترة المحددة",
  "this customer": "هذا العميل",
  "to review before posting": "للمراجعة قبل الترحيل",
  "were reviewed when this run was posted": "رُوجعت عند ترحيل هذا التشغيل",
  "{currency} 0.00 difference": "{currency} 0.00",
  "{months} months, {method} ({left} left)": "{months} شهرًا، {method} (متبقٍّ {left})",
  "{n} categories": "{n} فئة",
  "{n} exception left out - review them in the journal preview.": "{n} استثناء مستبعد - راجعه في معاينة القيد.",
  "{n} exceptions left out - review them in the journal preview.": "{n} استثناءات مستبعدة - راجعها في معاينة القيد.",
  "{n} months": "{n} شهرًا",
  "{n} mos": "{n} شهر",
  "{n} qualifying fixed assets": "{n} أصلًا ثابتًا مؤهلًا",
  "{n} rates imported.": "تم استيراد {n} سعر.",
  "{n} records loaded from {file}. All rows valid.": "تم تحميل {n} سجل من {file}. جميع الصفوف صالحة.",
  "{n} scheduled": "{n} مجدول",
  "{n} transfer moved between currencies without an FX rate.": "{n} تحويل انتقل بين عملات دون سعر صرف.",
  "{n} transfers moved between currencies without an FX rate.": "{n} تحويلات انتقلت بين عملات دون سعر صرف.",
  "{ref} approved: {tag} is derecognised and journal {journal} was posted.": "تم اعتماد {ref}: أُلغي الاعتراف بـ {tag} ورُحِّل القيد {journal}.",
  "{ref} endorsed. It now waits for Finance Controller approval.": "تم تأييد {ref}. بانتظار اعتماد المراقب المالي الآن.",
  "{ref} was rejected.": "تم رفض {ref}.",
  "{run} ({journal}) stays unchanged. The adjustment posts in the next open period and references the original run and journal.": "يبقى {run} ({journal}) دون تغيير. تُرحَّل التسوية في الفترة المفتوحة التالية وتشير إلى التشغيل والقيد الأصليين.",
  "{run} is posted. Corrections are never made in place - post an Adjustment in the next open period.": "تم ترحيل {run}. لا تُجرى التصحيحات مباشرة - رحّل تسوية في الفترة المفتوحة التالية.",
  // Depreciation run exceptions returned by the API
  'Missing cost': 'التكلفة مفقودة',
  'Missing in-service date': 'تاريخ بدء الخدمة مفقود',
  'No Book Policy': 'لا توجد سياسة دفتر',
  'No GL mapping': 'لا يوجد ربط بالأستاذ العام',
  'The Book has no cost - enter the acquisition cost': 'لا توجد تكلفة في الدفتر - أدخل تكلفة الاقتناء',
  'The Book has no in-service date': 'لا يوجد تاريخ بدء خدمة في الدفتر',
  'The asset has no acquisition cost on the register': 'لا توجد تكلفة اقتناء للأصل في السجل',
  'The asset has no purchase / in-service date on the register': 'لا يوجد تاريخ شراء / بدء خدمة للأصل في السجل',
};
